import React, { FC, useRef, useState } from 'react';
import Button from '../Button';
import InstructionPopup from './instructionsPopup';

type CalculativeFieldProps = {
    formState: any;
    selectedData: any;
    dataFromModal: any;
    storeHistory: (field: string, value: any, type: string) => void;
};

const CalculativeField: FC<CalculativeFieldProps> = ({ formState, selectedData, dataFromModal, storeHistory }) => {
    const contentEditableRef = useRef<HTMLDivElement>(null);
    const [openInstructions, setOpenInstructions] = useState(false)


    //for future use
    // useEffect(() => {
    //     if (formState.getValues(`title`)) {
    //         const initialContent = formState.getValues(`title`);
    //         const extractedVariables = getVariables(initialContent);

    //         const contentEditableElement = contentEditableRef.current;

    //         const handleInput = (e: any) => {
    //             extractedVariables.forEach(variable => {
    //                 const variableText = `[@${variable}]`;
    //                 const currentContent = e.target.innerHTML;

    //                 // Restore the original content if the variable is modified
    //                 if (!currentContent.includes(variableText)) {
    //                     e.preventDefault();
    //                     contentEditableElement!.innerHTML = initialContent;
    //                     setCaretToEnd(contentEditableElement!);
    //                 }
    //             });
    //         };

    //         const handleClick = (e: MouseEvent) => {
    //             const target = e.target as HTMLElement;
    //             if (extractedVariables.some(variable => target.innerText.includes(`[@${variable}]`))) {
    //                 e.preventDefault();
    //             }
    //         };

    //         if (contentEditableElement) {
    //             contentEditableElement.addEventListener('input', handleInput);
    //             contentEditableElement.addEventListener('click', handleClick);
    //         }

    //         return () => {
    //             if (contentEditableElement) {
    //                 contentEditableElement.removeEventListener('input', handleInput);
    //                 contentEditableElement.removeEventListener('click', handleClick);
    //             }
    //         };
    //     }
    // }, [formState]); // Only run this effect when formState changes

    // const setCaretToEnd = (element: HTMLElement) => {
    //     const range = document.createRange();
    //     const selection = window.getSelection();
    //     range.selectNodeContents(element);
    //     range.collapse(false);
    //     selection?.removeAllRanges();
    //     selection?.addRange(range);
    // };

    return (
        <React.Fragment>
            <h1 className="title">
                <span>
                    {selectedData?.index + 1}
                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 24 24">
                        <path d="M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z" fill={formState.watch('styles.color') || dataFromModal?.textColor} />
                    </svg>
                </span>
                <div
                    ref={contentEditableRef}
                    suppressContentEditableWarning
                    dangerouslySetInnerHTML={{ __html: formState.getValues(`title`) || "" }}
                    contentEditable
                    className="editable"
                    onInput={(e: any) => formState.setValue('title', e.target.innerHTML)}
                    onFocus={(e: any) => { storeHistory('title', e?.target?.value ?? "", 'slides') }}
                ></div>
            </h1>
            <div className='btn-container'>
                <Button btn_text='Click here for instructions' type='button' onClick={() => setOpenInstructions(true)} />
            </div>
            {openInstructions && <InstructionPopup title='Calculative field instruction' open={openInstructions} setOpen={setOpenInstructions} />}
        </React.Fragment>
    );
};

export default CalculativeField;
